import styled from 'styled-components';
import { color, space, textAlign } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { ThemeInterface } from '../theme/ThemeInterface';

const H1 = styled.h1<StyledSystemProps>`
  ${space};
  ${color};
  ${textAlign};
  font-family: ${(props: ThemeInterface) => props.theme.fontFamily};
  font-size: ${themeGet('fontSize[3]', '64px')};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H1;
